import { getApiV2Client, getSegmentsGetHlsClipPlaylistUrl } from '@mi-front/api-v2';

/**
 * Builds a signed clipped HLS playlist URL for a bounded station recording range.
 * The playlist segments already match `[from, to]`.
 */
export function buildStationClipHlsUrl(stationId: string, from: number, to: number): string {
  const { url } = getSegmentsGetHlsClipPlaylistUrl(stationId);

  return getApiV2Client().generateUrl(url, {
    secure: true,
    params: {
      from: String(from),
      to: String(to),
    },
  });
}
